module.exports = "<button id=\"goto-parent\">Goto parent</button>";